/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Position_UpdatedInputs */

const en_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption position updated`)
};

const fr_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position des sous-titres mise à jour`)
};

const de_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenposition aktualisiert`)
};

const it_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione didascalia aggiornata`)
};

const ru_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция подписи обновлена`)
};

const es_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición de subtítulo actualizada`)
};

const zh_cn2_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题位置已更新`)
};

const ja_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション位置を更新しました`)
};

const hi_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन स्थिति अपडेट की गई`)
};

const pt_pt2_caption_position_updated = /** @type {(inputs: Caption_Position_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição da legenda atualizada`)
};

/**
* | output |
* | --- |
* | "Caption position updated" |
*
* @param {Caption_Position_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position_updated = /** @type {((inputs?: Caption_Position_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Position_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_position_updated(inputs)
	if (locale === "de") return de_caption_position_updated(inputs)
	if (locale === "it") return it_caption_position_updated(inputs)
	if (locale === "ru") return ru_caption_position_updated(inputs)
	if (locale === "es") return es_caption_position_updated(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_position_updated(inputs)
	if (locale === "ja") return ja_caption_position_updated(inputs)
	if (locale === "hi") return hi_caption_position_updated(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_position_updated(inputs)
	return en_caption_position_updated(inputs)
});